import { render } from "./product-card.vue?vue&type=template&id=5f9f70f6&scoped=true&ts=true"
import script from "./product-card.vue?vue&type=script&lang=ts"
export * from "./product-card.vue?vue&type=script&lang=ts"

import "./product-card.vue?vue&type=style&index=0&id=5f9f70f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9f70f6"]])

export default __exports__